import React from "react";

const ErrorPage = () => {
  return (
    <div className="grid h-screen place-content-center bg-white">
      <p className="uppercase tracking-widest text-gray-500">404 | Not Found</p>
    </div>
  );
};

export default ErrorPage;
